import { render, staticRenderFns } from "./NewMemberAreaQuizz.vue?vue&type=template&id=ded3e9a6&scoped=true&"
import script from "./NewMemberAreaQuizz.vue?vue&type=script&lang=js&"
export * from "./NewMemberAreaQuizz.vue?vue&type=script&lang=js&"
import style0 from "./NewMemberAreaQuizz.vue?vue&type=style&index=0&id=ded3e9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded3e9a6",
  null
  
)

export default component.exports